// extracted by mini-css-extract-plugin
export var gif = "_j9-0";